module.exports = __webpack_public_path__ + "static/media/IMG-20220422-WA0019.6837eff8.jpg";